import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';

import Icon1 from '../../images/products/icon-1.svg'
import Icon2 from '../../images/products/icon-2.svg'
import Icon3 from '../../images/products/icon-3.svg'
import Icon4 from '../../images/products/icon-4.svg'
import Icon5 from '../../images/products/icon-5.svg'
import Icon6 from '../../images/products/icon-6.svg'
import Icon7 from '../../images/products/icon-7.svg'

class ThePlatformSolution extends Component {
	componentDidMount() {
		document.getElementById('root').classList.remove('welcome');
		document.getElementById("root").classList.remove("affiliate");
		document.getElementById('foo').classList.add('overflow');
	}
	render() {
		return (
			<div className="sub-page product">
				<Helmet>
					<title>STech - The Platform Solution</title>
					<meta name="description" content="STech - The Platform Solution pages" />
				</Helmet>
				<header className="clearfix fadeInUp">
					<div className="container">
						<div className="left"></div>
						<div className="right">
							<h1>The Platform Solution</h1>
							<h2>Products</h2>
						</div>
					</div>
				</header>
				<section className="clearfix fadeInUp">
					<div className="container partners">
						<div className="left"></div>
						<div className="right">
							<div className="content">
								Live in a couple of days, Hosted on a Content Delivery Network (CDN) - not a single server, Easy to use CMS interface = HTML + JavaScript = true, Unbeatable speeds and performances, Fast and easy rendering of ever-changing data, Unlimited usage without impeding loading or response times, and more…
							</div>
						</div>
					</div>
				</section>

				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">
							<img
								src={Icon4}
								title="Native Apps"
								alt="Native Apps"
							/>
						</div>
						<div className="col">
							<h3>Native Apps</h3>
							<span>All our brands will be launched in Apps</span>
							<ul>
								<li>All STech sites available on iOS and Android for both mobile & tablet devices</li>
								<li>Mobile responsive site (HTML5)</li>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">
							<img
								src={Icon6}
								title="Extensibility"
								alt="Extensibility"
							/>
						</div>
						<div className="col">
							<h3>Extensibility</h3>
							<span>Fully customizable for white-label</span>
							<ul>
								<li>Basic template in place for all products, however development of any customizable feature available upon request</li>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">
							<img
								src={Icon5}
								title="Agile"
								alt="Agile"
							/>
						</div>
						<div className="col">
							<h3>Agile</h3>
							<span>Quick development with launch in a day when other says a week</span>
							<ul>
								<li>In-house development team providing quick response to any issues</li>
								<li>72 hours SLA time</li>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp spec">
					<div className="back">
					<div className="container clearfix ">						
						<div className="left">
							<span>Reducing the demand on customer service-, fraud- and payment department</span>
						</div>
						<div className="right box">
							<h3>Fully Functional Responsible Gaming Features</h3>
							<img
								src={Icon2}
								title="Fully Functional Responsible Gaming Features"
								alt="Fully Functional Responsible Gaming Features"
							/>
							<ul>
								<li>In-built KYC check to ensure player age verification at time of first deposit</li>
								<li>Full fraud checks in-built with automated Email/SMS functionality</li>
								<li>Full certified & trained support team offering tips & guidance on processes</li>
								<li>Training available for your team as additional extra</li>
							</ul>
						</div>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp props">
					<div className="container no-border">
						<div className="col">
							<img
								src={Icon3}
								title="Seamless Wallet"
								alt="Seamless Wallet"
							/>
						</div>
						<div className="col">
							<h3>Seamless Wallet</h3>
							<span>Smooth payments and integrations, 1-wallet only</span>
							<ul>
								<li>Linked wallet enabling easy allocation of player funds between sports and casino</li>
								<li>Deposit methods include card, Neteller and Skrill, with more to follow</li>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">
							<img
								src={Icon1}
								title="Geo-redundancy"
								alt="Geo-redundancy"
							/>
						</div>
						<div className="col">
							<h3>Geo-redundancy</h3>
							
							<ul>
								<li>Online Customer Display Network allows for global hosting. This provides speedier & faster responsiveness to all sites.</li>
								<span>Ie: Customers from China get served from Chinese CDN for better latency to deliver superior performance.</span>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp props">
					<div className="container">
						<div className="col">
							<img
								src={Icon7}
								title="Multilingual"
								alt="Multilingual"
							/>
						</div>
						<div className="col">
							<h3>Multilingual</h3>
							<span>Global linguistic offering</span>
							<ul>
								<li>Internal Translation Tool enables translation in to all major official languages</li>
								<li>Currently live in English, German, Finnish, Polish & Japanese</li>
								<li>Over 5.000 languages available overall with more to follow</li>
							</ul>
						</div>
					</div>
				</section>
				<section className="clearfix fadeInUp contact">
					<div className="container">
						<h2>We grow together</h2>
						<div className="content">
							<p>STech is a hi-tech, fast-paced company but above all we aim to create business partnerships that grow over time.</p>
							<Link to="/contact">
								Contact Us
							</Link>
						</div>
					</div>
				</section>
			</div>
		);
	}
}

export default ThePlatformSolution
